import { render, staticRenderFns } from "./MentionItem.vue?vue&type=template&id=3f2ab17f"
import script from "./MentionItem.vue?vue&type=script&lang=js"
export * from "./MentionItem.vue?vue&type=script&lang=js"
import style0 from "./MentionItem.vue?vue&type=style&index=0&id=3f2ab17f&prod&lang=sass"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports